// extracted by mini-css-extract-plugin
module.exports = {"page":"BotRegistration_page__3BWFO"};